import Vue from 'vue'
import { Tabs, Form, Input, Select, Radio, DatePicker, Button, Checkbox, message, Spin, Modal } from 'ant-design-vue'
import Step from '@/components/step'
import ImgCaptcha from '@/components/imgcaptcha'
import SliderVerify from '@/components/slider-verify'
import 'moment/locale/zh-cn'

Vue.use(Tabs)
Vue.use(Form)
Vue.use(Input)
Vue.use(Select)
Vue.use(Radio)
Vue.use(DatePicker)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Step)
Vue.use(Spin)
Vue.use(Modal)
Vue.use(ImgCaptcha)
Vue.use(SliderVerify)
Vue.prototype.$message = message
Vue.prototype.$error = Modal.error
Vue.prototype.$info = Modal.info
Vue.prototype.$confirm = Modal.confirm
